<template>
    <article>
        <div class="article-title">{{ title }}</div>
        <div>
            <slot />
        </div>
    </article>
</template>
<script>
export default {
    props: {
        title: { type: String, default: null },
    },
};
</script>
<style lang="scss" scoped>
.article-title {
    font-size: 1.6rem;
    margin-bottom: 3rem;
}
</style>
